// @see inc/comp/ExportMediaLibrary.class.php
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import rmlOpts from "rmlopts";
import { Menu } from "@devowl-wp/react-folder-tree";
import { DashIcon } from "../components/index.js";
import { IS_DARKMODE, addUrlParam, hooks, urlBuilder } from "../util/index.js";
if (+rmlOpts.others.massedge_wp_export) {
    const { Item } = Menu;
    const { ItemGroup } = Menu;
    const SUPPORTS_SUBFOLDERS = +rmlOpts.others.childrenSql > 1;
    /**
     * Handle click on a menu item so the correct admin page can be called.
     */ const handleClick = function(e) {
        const baseUrl = urlBuilder({
            location: {
                path: "/massedge/export"
            }
        });
        const urlObj = new URL(baseUrl, window.location.href);
        urlObj.search = new URLSearchParams({
            type: e.key,
            folder: this.props.store.selectedId,
            _wpnonce: rmlOpts.restNonce
        }).toString();
        window.location.href = urlObj.toString();
    };
    /**
     * A function which is called to render the dropdown menu.
     */ const renderMenu = function() {
        const { store } = this.props;
        const { selected } = store;
        const isFolder = selected && (selected.id > 0 || selected.id === -1);
        if (!isFolder) {
            return /*#__PURE__*/ _jsx(Menu, {
                style: {
                    visibility: "hidden"
                }
            });
        }
        return /*#__PURE__*/ _jsxs(Menu, {
            onClick: handleClick.bind(this),
            theme: IS_DARKMODE ? "dark" : "light",
            children: [
                /*#__PURE__*/ _jsxs(ItemGroup, {
                    title: "Without RML subfolders",
                    children: [
                        /*#__PURE__*/ _jsx(Item, {
                            children: "As flat .zip file"
                        }, "wosFlat"),
                        /*#__PURE__*/ _jsx(Item, {
                            children: "As hierarchical .zip file (physical structure)"
                        }, "wosHierarchical")
                    ]
                }, "wos"),
                selected.id !== -1 && /*#__PURE__*/ _jsxs(ItemGroup, {
                    title: `Include RML subfolders${SUPPORTS_SUBFOLDERS ? "" : " (not supported by your system)"}`,
                    children: [
                        /*#__PURE__*/ _jsx(Item, {
                            disabled: !SUPPORTS_SUBFOLDERS,
                            children: "As flat .zip file"
                        }, "wsFlat"),
                        /*#__PURE__*/ _jsx(Item, {
                            disabled: !SUPPORTS_SUBFOLDERS,
                            children: "As hierarchical .zip file (RML structure)"
                        }, "wsHierarchicalRML"),
                        /*#__PURE__*/ _jsx(Item, {
                            disabled: !SUPPORTS_SUBFOLDERS,
                            children: "As hierarchical .zip file (physical structure)"
                        }, "wsHierarchical")
                    ]
                }, "ws")
            ]
        });
    };
    // Create download icon and register it to the toolbar
    hooks.register("tree/init", function() {
        this.stateRefs.ICON_DOWNLOAD_ZIP = /*#__PURE__*/ _jsx(DashIcon, {
            name: "download"
        });
        this.stateRefs.renderDownloadZipMenu = renderMenu.bind(this);
        // When clicking on the download icon in "All" or "Unorganized" redirect to usual export page
        this.stateRefs.handleDownloadZipClick = (function() {
            const { selectedId } = this.props.store;
            if (selectedId === "all" || this.props.store.selectedId === -1) {
                window.location.href = addUrlParam(window.location.href, "page", "mass-edge-export-media-library");
            }
        }).bind(this);
        this.state.toolbar_download_zip = {
            content: "ICON_DOWNLOAD_ZIP",
            toolTipTitle: "Download folder as zip",
            toolTipText: "A folder can be downloaded as flat or hierarchical zip.",
            menu: "resolve.renderDownloadZipMenu",
            toolTipPlacement: "topLeft",
            dropdownPlacement: "bottomLeft",
            onClick: "handleDownloadZipClick"
        };
        this.state.availableToolbarButtons.unshift("download_zip");
    });
}
